module.exports = __webpack_public_path__ + "static/media/feishu_document.0a8711be.png";